
import { defineComponent, computed } from 'vue'
import { useStore } from '@web/store'
import { useRouter, useRoute } from 'vue-router'

export default defineComponent({
  props: {
    title: {
      type: String,
      default: () => ''
    }
  },
  setup () {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const history = computed(() => store.getters['router/history'])
    const lastRouteNotSame = history.value.find(r => r.name !== route.name) || { name: 'courses' }

    function prevPage () {
      router.push(lastRouteNotSame)
    }

    return {
      prevPage
    }
  }
})
